import React, { memo, SVGProps } from 'react'

export const DotsVertical = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.6158 4C10.6158 4.76481 11.2352 5.3842 12 5.3842C12.7648 5.3842 13.3842 4.76481 13.3842 4C13.3842 3.23519 12.7648 2.6158 12 2.6158C11.2352 2.6158 10.6158 3.23519 10.6158 4ZM9 4C9 2.34111 10.3411 1 12 1C13.6589 1 15 2.34111 15 4C15 5.65889 13.6589 7 12 7C10.3411 7 9 5.6535 9 4Z"
      fill="currentColor"
    />
    <path
      d="M10.6158 12C10.6158 12.7648 11.2352 13.3842 12 13.3842C12.7648 13.3842 13.3842 12.7648 13.3842 12C13.3842 11.2352 12.7648 10.6158 12 10.6158C11.2352 10.6158 10.6158 11.2352 10.6158 12ZM9 12C9 10.3465 10.3411 9 12 9C13.6589 9 15 10.3411 15 12C15 13.6589 13.6589 15 12 15C10.3411 15 9 13.6535 9 12Z"
      fill="currentColor"
    />
    <path
      d="M10.6158 20C10.6158 20.7648 11.2352 21.3842 12 21.3842C12.7648 21.3842 13.3842 20.7648 13.3842 20C13.3842 19.2352 12.7648 18.6158 12 18.6158C11.2352 18.6158 10.6158 19.2352 10.6158 20ZM9 20C9 18.3465 10.3411 17 12 17C13.6589 17 15 18.3411 15 20C15 21.6589 13.6589 23 12 23C10.3411 23 9 21.6589 9 20Z"
      fill="currentColor"
    />
  </svg>
))
